import { Component } from '@angular/core';

@Component({
  selector: 'app-user-non-abonne',
  templateUrl: './user-non-abonne.component.html',
  styleUrls: ['./user-non-abonne.component.css']
})
export class UserNonAbonneComponent {

}
